module.exports = __webpack_public_path__ + "img/male3&harris.bfa37d5e.jpg";